import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { Accordion, Col, Row } from 'react-bootstrap';
import { JSONLD, Generic, GenericCollection } from 'react-structured-data';

import { getContentBlockItemValue, getContentBlockItemsByName, getContentBlockMixedItem } from '../../../CmsActions.js';
import HtmlComponent from '../../../../../components/Text/HtmlComponent.js';
import { stripTags } from '../../../../../util/text.js';

function PanelFaq({ panel }) {
    const title = getContentBlockItemValue(panel.blocks, 'title');
    const items = getContentBlockItemsByName(panel.blocks, 'questions')
        .map(item => ({
            question: (getContentBlockMixedItem(item, 'question') || {}).text,
            answer: (getContentBlockMixedItem(item, 'answer') || {}).text,
        }))
        .filter(qa => qa.question && qa.answer);

    if(!items.length) {
        return null;
    }

    // Split into two independent column stacks so expanding an item in the right
    // column never shifts the left one (column-major keeps the mobile order natural).
    const half = Math.ceil(items.length / 2);
    const columns = [{ id: 'faq-col-left', offset: 0, items: items.slice(0, half) }, { id: 'faq-col-right', offset: half, items: items.slice(half) }];

    return (
        <Fragment>
            <section className="my-4">
                {title && <h2 className="h4 mb-3">{title}</h2>}
                <Accordion alwaysOpen>
					<Row className="align-items-start">
						{columns.map(column => (
							<Col xs="12" lg="6" key={column.id}>
								{column.items.map((qa, index) => (
									<Accordion.Item eventKey={`${column.offset + index}`} key={qa.question} className="mb-0">
										<Accordion.Header>
											<span className="h6 fw-semibold mb-0">{qa.question}</span>
										</Accordion.Header>
										<Accordion.Body>
											<HtmlComponent text={qa.answer} />
										</Accordion.Body>
									</Accordion.Item>
								))}
							</Col>
						))}
					</Row>
                </Accordion>
            </section>

            {/* JSON-LD FAQPage : signal de citation IA (rich result FAQ retiré) */}
            <JSONLD dangerouslyExposeHtml>
                <Generic jsonldtype="FAQPage">
                    <GenericCollection type="mainEntity">
                        {items.map(qa => (
                            <Generic key={qa.question} jsonldtype="Question" schema={{ name: qa.question }}>
                                <Generic type="acceptedAnswer" jsonldtype="Answer" schema={{ text: stripTags(qa.answer) }} />
                            </Generic>
                        ))}
                    </GenericCollection>
                </Generic>
            </JSONLD>
        </Fragment>
    );
}

PanelFaq.propTypes = {
    panel: PropTypes.object.isRequired,
};

export default PanelFaq;
